import './ArtistPage.css'

import ArtistCard from './ArtistCard';
import { useData } from '../DataProvider';

const ArtistPage = () => {
    const { data, loading } = useData();

    if (loading) {
        return <div></div>;
    }

    return (
        <div>
            <div className='gap'></div>
            <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', left: '32px', }} >
                    <p className='default-text-bigger'>About Us</p>
                </div>
                <div className='about-us-center'>
                    <div className='default-text newline-able'>{data.texts['about-us']}</div>
                </div>
                <div className='gap'></div>
                <div className='artist-container'>
                    {data.profiles.map((item,index) => {
                        return <div className='artist-item'><ArtistCard jsonData={item}/></div>
                    })}
                </div>
                <div className='gap'></div>
            </div>
        </div>
    );
}

export default ArtistPage;
